import tns from 'tinyslider';

export default class Testimonial {

    constructor(root) {
        this.container = root;
        this.sliderContainer = this.container.querySelector('.slider-container .slider');
        this.leftButton = this.container.querySelector('.slider-container .arrow-left');
        this.rightButton = this.container.querySelector('.slider-container .arrow-right');
        this.dotsContainer = this.container.querySelector('.dots');
        this.countContainer = this.container.querySelector('.status span');

        if(this.sliderContainer.children.length > 1) {
            this.slider = tns({
                container: this.sliderContainer,
                items: 1,
                slideBy: 'page',
                center: true,
                loop: false,
                autoWidth: false,
                autoHeight: false,
                mouseDrag: true,
                controls: false,
                navContainer: this.dotsContainer,
                mode: "gallery",
                speed: 750,
                onInit: () => {this.fixSlideHeights()}
            });

            this.canScroll = true;
            this.sliderContainer.addEventListener('wheel', e => {
                if(!this.canScroll || Math.abs(e.deltaX) < 10) {
                    return;
                }

                this.canScroll = false;
                setTimeout(() => {
                    this.canScroll = true;
                }, 500);

                let scrollDir = e.deltaX >= 1 ? 1 : -1;

                if(scrollDir > 0) {
                    this.slider.goTo('next');
                } else {
                    this.slider.goTo('prev');
                }
            });


            this.leftButton.addEventListener('click', () => this.slider.goTo('prev'));
            this.rightButton.addEventListener('click', () => this.slider.goTo('next'));
            this.slider.events.on('indexChanged', (info) => this.handleSlideChange(info, this));
        }
    }

    fixSlideHeights() {
        let max = 0;
        this.sliderContainer.querySelectorAll('.card').forEach(card => {
            if(card.getBoundingClientRect().height > max) {
                max = card.getBoundingClientRect().height;
            }
        });

        this.sliderContainer.querySelectorAll('.card').forEach(card => {
            card.style.minHeight = `${max}px`;
        });
    }

    handleSlideChange(info, instance) {
        instance.countContainer.innerText = `${info.displayIndex}/${info.slideCount}`;
        instance.leftButton.disabled = info.displayIndex <= 1;
        instance.rightButton.disabled = info.displayIndex >= info.slideCount;
    }
}